import { inject, Injectable } from '@angular/core'
import { createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, switchMap } from 'rxjs/operators'

import { hasNoCompetitions, mapSeasons } from '@core/utils/season.utils'
import { SeasonsApi } from '@features/seasons/api/seasons.api'
import { EffectsBase } from '@core/store/effects/effects.base'
import { Season } from '@core/models/season-competition.models'
import { requestErrorHandler } from '@shared/operators/request-error.operator'
import { goToPage } from '@core/ngrx-router/state/actions/ngrx-router.actions'
import { RouteUrl } from '@core/enums/routing.enums'
import {
  fetchSeasons,
  setCurrentSeason,
  setNoCompetitions,
  setSeasonsByContext
} from '@features/seasons/state/actions/seasons.actions'

@Injectable()
export class SeasonsEffects extends EffectsBase {
  private readonly _api = inject(SeasonsApi)

  fetchSeasons$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fetchSeasons),
      mergeMap(({ includeMatchdays, callingContext }) =>
        this._api.fetchSeasons(includeMatchdays, callingContext).pipe(
          map((seasons: { seasons: Season[] }) => mapSeasons(seasons)),
          map((seasons: Season[]) => ({
            seasons: seasons.length ? [{ ...seasons[0], current: true }, ...seasons.slice(1)] : seasons,
            callingContext,
            current: seasons[0]
          })),
          requestErrorHandler()
        )
      ),
      switchMap(({ seasons, callingContext, current }) =>
        hasNoCompetitions(seasons)
          ? [setNoCompetitions(), goToPage({ page: RouteUrl.NoCompetitions })]
          : [
              setSeasonsByContext({ callingContext, seasons }),
              setCurrentSeason({ callingContext, current, keepOriginalOnExist: true })
            ]
      )
    )
  )
}
